import React, { useState, useEffect } from "react";
import {
  createFaqService,
  getFaqService,
  updateFaqService,
  deleteFaqService,
} from "../../../services/apiService";

const AdminFaq = () => {
  const [faqs, setFaqs] = useState([]);

  const fetchFaqs = async () => {
    try {
      const data = await getFaqService();
      const list = Array.isArray(data) ? data : data?.Data || [];
      setFaqs(
        list.map((item) => ({
          sno: item.sno || item.id,
          question: item.faq_ques || item.question,
          answer: item.faq_ans || item.answer,
          active: item.active,
        })),
      );
    } catch (error) {
      console.error("Failed to fetch FAQs:", error);
    }
  };

  useEffect(() => {
    fetchFaqs();
  }, []);

  const [showModal, setShowModal] = useState(false);

  const [currentFaq, setCurrentFaq] = useState({
    sno: null,
    question: "",
    answer: "",
    active: "true",
  });

  const handleEdit = (faq) => {
    setCurrentFaq({
      sno: faq.sno,
      question: faq.question,
      answer: faq.answer,
      active: faq.active,
    });

    setShowModal(true);
  };
  const handleAdd = () => {
    setCurrentFaq({
      sno: null,
      question: "",
      answer: "",
    });
    setShowModal(true);
  };

  const handleSave = async () => {
    try {
      if (!currentFaq.question.trim()) {
        alert("Please enter a question.");
        return;
      }

      if (!currentFaq.answer.trim()) {
        alert("Please enter an answer.");
        return;
      }

      if (currentFaq.sno) {
        await updateFaqService(currentFaq.sno, {
          faq_ques: currentFaq.question,
          faq_ans: currentFaq.answer,
          active: currentFaq.active,
        });
      } else {
        const response = await createFaqService({
          faq_ques: currentFaq.question,
          faq_ans: currentFaq.answer,
          created_by: localStorage.getItem("userId"),
          active: 1,
        });

        setFaqs((prev) => [
          ...prev,
          {
            sno: response?.sno || response?.id || Date.now(),
            question: currentFaq.question,
            answer: currentFaq.answer,
          },
        ]);
      }

      setCurrentFaq({ sno: null, question: "", answer: "" });
      setShowModal(false);
      fetchFaqs();
    } catch (error) {
      console.error(error);
      alert("Failed to save FAQ.");
    }
  };

  return (
    <div style={styles.container}>
      <div style={styles.header}>
        <h2 style={styles.title}>FAQ Management</h2>

        <button style={styles.addBtn} onClick={handleAdd}>
          + Add FAQ
        </button>
      </div>

      {faqs.map((faq, index) => (
        <div key={faq.sno} style={styles.card}>
          <div
            style={{
              flex: 1,
              display: "flex",
              alignItems: "center",
              gap: "12px",
            }}
          >
            <span style={styles.serialNo}>{index + 1}.</span>

            <strong>{faq.question}</strong>
          </div>

          <div style={styles.actions}>
            <label style={styles.switch}>
              <input
                type="checkbox"
                checked={Boolean(faq.active)}
                onChange={() => handleToggle(faq)}
              />
              <span style={styles.slider}></span>
            </label>

            <button style={styles.editBtn} onClick={() => handleEdit(faq)}>
              Edit
            </button>
          </div>
        </div>
      ))}

      {showModal && (
        <div style={styles.overlay}>
          <div style={styles.modal}>
            <h3>{currentFaq.sno ? "Edit FAQ" : "Add FAQ"}</h3>

            <label style={styles.label}>Question</label>

            <input
              style={styles.input}
              value={currentFaq.question}
              onChange={(e) =>
                setCurrentFaq({
                  ...currentFaq,
                  question: e.target.value,
                })
              }
            />

            <label style={styles.label}>Answer</label>

            <textarea
              rows={8}
              style={styles.textarea}
              value={currentFaq.answer}
              onChange={(e) =>
                setCurrentFaq({
                  ...currentFaq,
                  answer: e.target.value,
                })
              }
            />
            <label style={styles.checkboxLabel}>
              <input
                type="checkbox"
                checked={currentFaq.active}
                onChange={(e) =>
                  setCurrentFaq({
                    ...currentFaq,
                    active: e.target.checked,
                  })
                }
              />
              <span style={{ marginLeft: "8px" }}>
                {currentFaq.active ? "Active " : "Inactive"}
              </span>
            </label>

            <div style={styles.footer}>
              <button
                style={styles.cancelBtn}
                onClick={() => setShowModal(false)}
              >
                Cancel
              </button>

              <button style={styles.saveBtn} onClick={handleSave}>
                Save
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default AdminFaq;

const styles = {
  container: {
    padding: 20,
    background: "#fff",
  },

  header: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    marginBottom: 20,
  },

  title: {
    margin: 0,
    color: "#005487",
  },
  actions: {
    display: "flex",
    alignItems: "center",
    gap: "10px",
  },

  serialNo: {
    fontWeight: "bold",
    color: "#005487",
    minWidth: "25px",
  },

  switch: {
    display: "flex",
    alignItems: "center",
  },

  addBtn: {
    background: "#005487",
    color: "#fff",
    border: "none",
    padding: "10px 18px",
    borderRadius: 5,
    cursor: "pointer",
  },

  list: {
    display: "flex",
    flexDirection: "column",
    gap: 12,
  },

  card: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    border: "1px solid #ddd",
    padding: 15,
    borderRadius: 6,
    background: "#fafafa",
  },

  editBtn: {
    background: "#ff9800",
    color: "#fff",
    border: "none",
    padding: "8px 15px",
    borderRadius: 4,
    cursor: "pointer",
  },

  deleteBtn: {
    background: "#dc3545",
    color: "#fff",
    border: "none",
    padding: "8px 15px",
    borderRadius: 4,
    cursor: "pointer",
    marginLeft: 8,
  },

  overlay: {
    position: "fixed",
    inset: 0,
    background: "rgba(0,0,0,.45)",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    zIndex: 999,
  },

  modal: {
    width: "700px",
    background: "#fff",
    borderRadius: 8,
    padding: 25,
  },

  label: {
    display: "block",
    marginTop: 15,
    marginBottom: 6,
    fontWeight: "bold",
  },

  input: {
    width: "100%",
    padding: 10,
    border: "1px solid #ccc",
    borderRadius: 5,
  },

  textarea: {
    width: "100%",
    padding: 10,
    border: "1px solid #ccc",
    borderRadius: 5,
    resize: "vertical",
  },

  footer: {
    display: "flex",
    justifyContent: "flex-end",
    gap: 10,
    marginTop: 20,
  },

  cancelBtn: {
    padding: "10px 20px",
    border: "1px solid #ccc",
    background: "#fff",
    cursor: "pointer",
    borderRadius: 5,
  },

  saveBtn: {
    padding: "10px 20px",
    background: "#005487",
    color: "#fff",
    border: "none",
    cursor: "pointer",
    borderRadius: 5,
  },
};
